import { Typography } from "@mui/material";

export default function TransTextView({ content, sx }) {
  return (
    <Typography fontSize={14} fontWeight={600} sx={{ ...sx }}>
      {content}
    </Typography>
  );
}
